var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    "data-bbox": "16.5 15.959 167.001 167.941",
    viewBox: "16.5 15.959 167.001 167.941",
    height: 200,
    width: 200,
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "color",
    role: "presentation",
    "aria-hidden": "true",
    "aria-label": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "#comp-kxyo0t83 svg [data-color=\"1\"] {fill: #CA9400;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M180.3 19.2c-3.7-3.7-9.9-4.9-14.7 0l-11.1 11.2c-.4-.3-.9-.4-1.5-.4H20c-1.9 0-3.5 1.6-3.5 3.5v146.9c0 1.9 1.5 3.5 3.5 3.5h132.1c1.9 0 3.5-1.6 3.5-3.5V61.9c0-.9-.3-1.6-.9-2.2L180.3 34c4.8-4.9 3.7-11.1 0-14.8zm-31.6 157.7H23.5V37h124.3L99.1 86c-.3.3-.5.6-.7.9l-9.8 19.8c-.7 1.4-.4 3 .7 4 .7.7 1.5 1 2.5 1 .5 0 1-.1 1.5-.3l19.7-9.9c.3-.2.6-.4.9-.7l34.8-35v111.1zm26.7-147.8l-66 66.4-9.8 4.9 4.9-9.9 66-66.4c2.3-2.3 4.5-.3 4.9 0 .4.5 2.3 2.6 0 5z",
    fill: "#E4A118",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.8 150.7H47.7c-1.9 0-3.5 1.6-3.5 3.5s1.5 3.5 3.5 3.5h79.1c1.9 0 3.5-1.6 3.5-3.5 0-2-1.5-3.5-3.5-3.5z",
    fill: "#E4A118",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2 128.8c0 1.9 1.5 3.5 3.5 3.5h79.1c1.9 0 3.5-1.6 3.5-3.5s-1.5-3.5-3.5-3.5H47.7c-1.9 0-3.5 1.6-3.5 3.5z",
    fill: "#E4A118",
    "data-color": 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step-3.b280b984558214a1c598cbc742e3be72.svg";
export { ForwardRef as ReactComponent };